module.exports = __webpack_public_path__ + "img/logo-government-8.3dcdca3e.png";